/**
 * Permissive email shape check that mirrors the server-side rule
 * (apps/nexus/nexus/services/attendee_enrichment.rs::validate_email_shape):
 * exactly one '@', non-empty local part, non-empty domain with a '.'.
 *
 * Apollo is the source of truth for "real" person — this check only
 * filters obvious typos so we don't round-trip them.
 */
export function isValidEmailShape(raw: string): boolean {
  const trimmed = raw.trim();
  const parts = trimmed.split('@');
  if (parts.length !== 2) return false;
  const [local, domain] = parts;
  if (local.length === 0 || domain.length === 0) return false;
  if (!domain.includes('.')) return false;
  return true;
}
